/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Basic_SalaryInputs */

const en_pricing_feature_basic_salary = /** @type {(inputs: Pricing_Feature_Basic_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic salary data`)
};

const de_pricing_feature_basic_salary = /** @type {(inputs: Pricing_Feature_Basic_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundlegende Gehaltsdaten`)
};

const fr_pricing_feature_basic_salary = /** @type {(inputs: Pricing_Feature_Basic_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données salariales de base`)
};

const es_pricing_feature_basic_salary = /** @type {(inputs: Pricing_Feature_Basic_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos salariales básicos`)
};

const it_pricing_feature_basic_salary = /** @type {(inputs: Pricing_Feature_Basic_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati salariali di base`)
};

const nl_pricing_feature_basic_salary = /** @type {(inputs: Pricing_Feature_Basic_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basisgegevens over salaris`)
};

const pl_pricing_feature_basic_salary = /** @type {(inputs: Pricing_Feature_Basic_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podstawowe dane dotyczące wynagrodzenia`)
};

const fi_pricing_feature_basic_salary = /** @type {(inputs: Pricing_Feature_Basic_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruspalkkatiedot`)
};

const da_pricing_feature_basic_salary = /** @type {(inputs: Pricing_Feature_Basic_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundlønningsdata`)
};

const sv_pricing_feature_basic_salary = /** @type {(inputs: Pricing_Feature_Basic_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundläggande lönedata`)
};

/**
* | output |
* | --- |
* | "Basic salary data" |
*
* @param {Pricing_Feature_Basic_SalaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_basic_salary = /** @type {((inputs?: Pricing_Feature_Basic_SalaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Basic_SalaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_basic_salary(inputs)
	if (locale === "fr") return fr_pricing_feature_basic_salary(inputs)
	if (locale === "es") return es_pricing_feature_basic_salary(inputs)
	if (locale === "it") return it_pricing_feature_basic_salary(inputs)
	if (locale === "nl") return nl_pricing_feature_basic_salary(inputs)
	if (locale === "pl") return pl_pricing_feature_basic_salary(inputs)
	if (locale === "fi") return fi_pricing_feature_basic_salary(inputs)
	if (locale === "da") return da_pricing_feature_basic_salary(inputs)
	if (locale === "sv") return sv_pricing_feature_basic_salary(inputs)
	return en_pricing_feature_basic_salary(inputs)
});